// extracted by mini-css-extract-plugin
module.exports = {"debug":"cardPartners_debug__3uZEn","partnerContainer":"cardPartners_partnerContainer__33ujX","title":"cardPartners_title__2Ubs_"};